
export const setReportListType = listType => ({
  type: 'SET_REPORT_LIST_TYPE',
  listType: listType
})
